// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.preview-app-width {
    width: 870px;
}

.preview-app-live-mode-width {
    width: 325px;
}

.white-space {
    white-space: normal;
    height: auto;
}

.map {
    width: 95%;
    height: 700px;
}`, "",{"version":3,"sources":["webpack://./src/asset/style/manualmode/preview_app.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,aAAa;AACjB","sourcesContent":[".preview-app-width {\n    width: 870px;\n}\n\n.preview-app-live-mode-width {\n    width: 325px;\n}\n\n.white-space {\n    white-space: normal;\n    height: auto;\n}\n\n.map {\n    width: 95%;\n    height: 700px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
